<template>
    <b-container fluid="true" class="MeteoComponent">
        <b-row tag="header">
            <h1 class="SectionTitle">Conditions météo :</h1>
        </b-row>
        <b-row tag="section">
            <b-col>
                <b-row>
                  <b-col tag="header" class="MeteoDataHeader">
                    <img class="DataIcon" src="../../assets/img/icons/sun_iconflat.svg" alt="sun iconflat">
                    <b-form-select class="DataSelectEdit" v-if="edit" v-model="meteo.weather" :options="meteoOptions" :disabled="!edit"></b-form-select>
                    <span v-else class="info-title DataInputNoEdit">
                            {{ $t('global.meteo.' + meteo.weather) }}
                        </span>
                  </b-col>
                  <div class="w-100"></div>
                  <b-col tag="footer">
                        <h2 class="DataTitle">Ciel</h2>
                    </b-col>
                </b-row>
            </b-col>
            <b-col>
                <b-row>
                   <b-col tag="header" class="MeteoDataHeader">
                     <img class="DataIcon" src="../../assets/img/icons/wind_iconflat.svg" alt="sun iconflat" height="16" width="16">
                     <div v-if="edit" class="DataInputEdit">
                        <b-form-input type="number" min="0" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : 0" v-model="meteo.windSpeed" :placeholder="$t('global.wind.windSpeed')"></b-form-input>
                        <p>(Knot)</p>
                      </div>
                      <span v-else class="DataInputNoEdit">
                              {{ meteo.windSpeed | units('knot','knot', true) | truncate(0)  }}
                         </span>
                    </b-col>
                    <div class="w-100"></div>
                    <b-col tag="footer">
                          <h2 class="DataTitle">Vitesse du vent</h2>
                      </b-col>
                </b-row>
            </b-col>
            <b-col>
                <b-row>
                    <b-col tag="header" class="MeteoDataHeader">
                      <img class="DataIcon" src="../../assets/img/icons/windflag_iconflat.svg" alt="sun iconflat" height="16" width="16">
                      <div v-if="edit" class="DataInputEdit">
                        <b-form-input type="number" min="0" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : 0" v-model="meteo.windDirection" :placeholder="$t('global.wind.windDirection')"></b-form-input>
                        <p>(deg)</p>
                      </div>
                      <span v-else class="DataInputNoEdit">
                              {{ meteo.windDirection | units('deg','deg', true) | truncate(0) }}
                          </span>
                    </b-col>
                  <div class="w-100"></div>
                  <b-col tag="footer">
                        <h2 class="DataTitle">Direction du vent</h2>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name:"MeteoControl",
    data() {
        return {
            meteoOptions:[
                {value:"sunny",text:this.$t('global.meteo.sunny')},
                {value:"rainy",text:this.$t('global.meteo.rainy')},
                {value:"cloudy",text:this.$t('global.meteo.cloudy')},
                {value:"snowy",text:this.$t('global.meteo.snowy')}
            ]
        }
    },
    props:{
        meteo:Object,
        edit:{
            type: Boolean,
            default: false
        }
    },
    mounted(){

    },
    methods:{
        toggleEdit(){
            this.edit = !this.edit;
        }
    }
}
</script>

<style>
    @import "../../style/App.scss";
    @import "../../style/components/meteo/MeteoControl.scss";
</style>